var findInteractions = (map, predicate) => {
  var interactions = map.getInteractions().getArray();

  if (predicate) {
    return interactions.filter(predicate);
  }

  return interactions;
};

export default findInteractions;